module.exports = __webpack_public_path__ + "media/images/photos/ppf-95119821a8d267517b144fd742802c6b.jpg";